import { Drawer } from 'antd';
import getFormatMessage from '../../../../../locales/get-format-message';
import closeIcon from '../../../../../assets/svg/close-icon.svg';
import warnBlueIcon from '../../../../../assets/svg/warn-blue.svg';
import { useEffect, useState } from 'react';
import {
  // IRechargeHistoryItem,
  IRechargeHistoryList,
  RechargeHistoryType,
} from '../../../../../model/billing-center';
import { getRechargeHistoryList } from '../../../../../api';
import { messageError } from '../../../../../components/message';
import { getFormatDateTime, getPrice } from '../../../../../lib';
import { AutoTable } from '../../../../../components/auto-table';

interface IProps {
  readonly onClose: (status?: boolean) => void;
  readonly studioId: string;
}

export const RechargeRecordDrawer = (props: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [filterTable, setFilterTable] = useState<
    ReadonlyArray<IRechargeHistoryList>
  >([]);
  const getRechargeHistory = async () => {
    setLoading(true);
    try {
      const res = await getRechargeHistoryList(props.studioId);
      if (res) {
        setFilterTable(res.list);
      }
    } catch (error) {
      console.log(error);
      messageError(getFormatMessage('query_fail'));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getRechargeHistory();
  }, []);

  const handleOpenCancel = () => {
    props.onClose();
  };
  const COLUMNS = [
    // 暂时屏蔽
    // {
    //   name: getFormatMessage('remittance_name'),
    //   key: 'receive_bank_openname',
    //   fixed: false,
    // },
    // {
    //   name: getFormatMessage('remittance_bank'),
    //   key: 'receive_bank_name',
    //   fixed: false,
    // },
    // {
    //   name: getFormatMessage('remittance_id'),
    //   key: 'receive_bank_account',
    // },
    {
      name: getFormatMessage('remittance_money'),
      key: 'amt',
      tableExtension: {
        renderRow(_key: any, _value: string) {
          return getPrice(_value).amount;
        },
      },
    },
    {
      name: getFormatMessage('remittance_time'),
      key: 'provide_time',
      tableExtension: {
        renderRow(_key: any, _value: Date) {
          return getFormatDateTime(_value);
        },
      },
    },
    {
      name: getFormatMessage('status'),
      key: 'order_state',
      width: 110,
      // className: 'fixed-column',
      // fixed: 'right' as const,
      tableExtension: {
        renderRow(_key: any, _value: RechargeHistoryType) {
          const statusMapping = {
            [RechargeHistoryType.SystemReviewOne]: {
              text: getFormatMessage('system_review'),
              color: '#86909C',
            },
            [RechargeHistoryType.SystemReviewTwo]: {
              text: getFormatMessage('system_review'),
              color: '#86909C',
            },
            [RechargeHistoryType.RechargingOne]: {
              text: getFormatMessage('recharging'),
              color: '#86909C',
            },
            [RechargeHistoryType.RechargingTwo]: {
              text: getFormatMessage('recharging'),
              color: '#86909C',
            },
            // [RechargeHistoryType.ReviewFailed]: { text: getFormatMessage('system_not_pass'), color: '#F54E4E' },
            [RechargeHistoryType.AccountCredited]: {
              text: getFormatMessage('already_received'),
              color: '#3EC688',
            },
          };

          const { text, color } = statusMapping[_value] || {
            text: '',
            color: '',
          };
          return <span style={{ color }}>{text}</span>;
        },
        className: 'fixed-column',
        fixed: 'right' as const,
      },
    },
  ];

  return (
    <Drawer
      onClose={() => props.onClose()}
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>{getFormatMessage('recharge_record_title')}</span>
          <img
            src={closeIcon}
            className="sync-close-icon"
            onClick={() => props.onClose()}
          />
        </div>
      }
      placement="right"
      width={1032}
      closable={false}
      visible={true}
      headerStyle={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        marginLeft: '3px',
      }}
      footer={
        <div
          style={{
            textAlign: 'left',
          }}
        >
          <button className="gc-btn sub-button" onClick={handleOpenCancel}>
            {getFormatMessage('close')}
          </button>
        </div>
      }
    >
      <div className="re-report">
        <div className="re-report-description">
          <img src={warnBlueIcon} className="warn-blue-icon" />
          <div className="re-report-text">
            {getFormatMessage('recharge_record_q')}
          </div>
          <div className="re-report-text">
            {getFormatMessage('recharge_record_a')}
          </div>
          {/* <div className="re-report-text">
            👉 更多疑问解答，如：
            <span className="blue-span">对公汇款时填错账号处理方法</span>
          </div> */}
        </div>
        {/* 表格 */}
        <AutoTable
          loading={loading}
          // rowKey="id"
          // rowKey={(record) => record.UserID}
          list={filterTable || []}
          configFields={COLUMNS}
          tableExtension={{
            rowKey: 'roleId',
            pagination: {
              current: currentPage,
              total: filterTable.length,
              pageSize,
              showTotal: (total) => {
                return getFormatMessage('total_items', {
                  params: {
                    total,
                  },
                });
              },
            },
            onChange: (changeInfo) => {
              if (!changeInfo) {
                return;
              }
              setCurrentPage(changeInfo.current);
              setPageSize(changeInfo.pageSize || 10);
            },
            // scroll: { x: 1100 }
          }}
          className="re-report-table"
        />
      </div>
    </Drawer>
  );
};
